import { getDeviceId, getItemFromLocalStorage } from './common';

export const sentryBeforeSend = async event => {
  // check if tags is present then only push events to sentry
  if (event.tags && (event.tags.label || event.tags.priority === 'p0')) {
    const oopsPageRendered = !!document?.querySelector(
      '.error-boundary-container',
    );

    // This would tell us whether particular error resulted in app crash or not
    Object.assign(event.tags, {
      oopsPageRendered,
      deviceId: await getDeviceId(),
    });

    // Identify users facing issues
    Object.assign(event, {
      user: {
        id: getItemFromLocalStorage('merchantId'),
      },
    });
    return event;
  }
  return null;
};
